module.exports = __webpack_public_path__ + "flag-61676924ce80555df1561c9ef20328bd.svg";